import { render } from "./ModuleHeader.vue?vue&type=template&id=42b91766&scoped=true"
import script from "./ModuleHeader.vue?vue&type=script&lang=js"
export * from "./ModuleHeader.vue?vue&type=script&lang=js"

import "./ModuleHeader.vue?vue&type=style&index=0&id=42b91766&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b91766"]])

export default __exports__